import { Box, MenuItem, styled, Typography } from '@mui/material';

interface SubHeaderContainerProps {
  alignItems?: string;
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
}

export const SubHeaderContainer = styled(Box)<SubHeaderContainerProps>`
  padding: 0px 0 2px 0;
  display: flex;
  justify-content: space-between;
  align-items: ${({ alignItems = 'center' }) => alignItems};
  ${({
    flexDirection,
  }: {
    flexDirection?: SubHeaderContainerProps['flexDirection'];
  }) => flexDirection && `flex-direction: ${flexDirection};`}
`;

export const StyledLabel = styled('label')<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 500,
    display: 'inline-block',
    marginBottom: '2px',
    userSelect: disabled ? 'none' : 'auto',
    cursor: disabled ? 'not-allowed' : 'pointer',
    textAlign: 'left',
    opacity: disabled ? 0.6 : 1,
    '&:focus, &:active': {
      userSelect: disabled ? 'none' : 'auto',
    },
  }),
);

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop: any) => prop !== 'paddingTop',
})<{ paddingTop?: number }>(({ theme, paddingTop }) => ({
  color: theme.palette.text.secondary,
  paddingTop: paddingTop !== undefined ? theme.spacing(paddingTop) : undefined,
}));

export const HeaderContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const TitleContainer = styled('div')({
  flex: 1,
});

export const ActionsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 24,
});

export const FlexRowCenter = styled(Box)`
  display: flex;
  align-items: center;
`;

export const NoWrapTypography = styled(Typography)`
  margin-right: 8px;
  white-space: nowrap;
`;

export const StyledPageMenuItem = styled(MenuItem)`
  width: 100px;
`;

export const HeaderText = styled(Typography)`
  font-size: 1.75rem;
  font-weight: 400;
  margin-bottom: 0.35em;
  flex: 1;
  padding-right: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
